import amfiteatr from './svg/Amfiteatr.png';
import bank from './svg/Bank.svg';
import Apteka from './svg/Apteka.svg';
import Bankomat from './svg/Bankomat.svg';
import Basen from './svg/Basen.svg';
import Biblioteka from './svg/Biblioteka.svg';
import Budynek_zabytkowy from './svg/Budynek zabytkowy.svg';
import Bunkier from './svg/Bunkier.svg';
import Cerkiew from './svg/Cerkiew.svg';
import Cerkiew_zabytkowa from './svg/Cerkiew zabytkowa.svg';
import Cmentarz from './svg/Cmentarz.svg';
import Cmentarz_zabytkowy from './svg/Cmentarz zabytkowy.svg';
import Dom_kultury_świetlica from './svg/Dom kultury_świetlica.svg';
import Dom_zdrojowy from './svg/Dom zdrojowy.svg';
import Dworek_palac from './svg/Dworek_pałac.svg';
import Dworzec_autobusowy from './svg/Dworzec autobusowy.svg';
import Dworzec_stacja_kolejowa from './svg/Dworzec_stacja kolejowa.svg';
import Filharmonia_opera from './svg/Filharmonia_opera.svg';
import Fontanna from './svg/Fontanna.svg';
import Fort_twierdza from './svg/Fort_twierdza.svg';
import Gabinet_lekarski from './svg/Gabinet lekarski.svg';
import Galeria_handlowa from './svg/Galeria handlowa.svg';
import Grodzisko_kurhan from './svg/Grodzisko_kurhan.svg';
import inne from './svg/Inne.svg';
import Informacja_turystyczna from './svg/Informacja turystyczna.svg';
import Inny_obiekt_historyczny from './svg/Inny obiekt historyczny.svg';
import Inny_obiekt_kultu_religijnego from './svg/Inny obiekt kultu religijnego.svg';
import Inny_obiekt_kultury_i_rozrywki from './svg/Inny obiekt kultury i rozrywki.svg';
import Inny_obiekt_przyrodniczy from './svg/Inny obiekt przyrodniczy.svg';
import Inny_obiekt_sportu_i_wypoczynku from './svg/Inny obiekt sportu i wypoczynku.svg';
import Inny_obiekt_użyteczności_publicznej from './svg/Inny obiekt użyteczności publicznej.svg';
import Inny_obiekt_związany_z_transportem from './svg/Inny obiekt związany z transportem.svg';
import Interesujaca_osobliwosc_przyrodnicza from './svg/Interesująca osobliwość przyrodnicza.svg';
import Kamieniolom from './svg/Kamieniołom.svg';
import Kapliczka from './svg/Kapliczka.svg';
import Kino from './svg/Kino.svg';
import Kirkut from './svg/Kirkut.svg';
import Klub_gier_i_innych_rozrywek from './svg/Klub gier i innych rozrywek.svg';
import Klub_muzyczny from './svg/Klub muzyczny.svg';
import Kosciol from './svg/Kościół.svg';
import Kosciol_zabytkowy from './svg/Kościół zabytkowy.svg';
import Krzyz_figura from './svg/Krzyż_figura.svg';
import Lesniczowka_gajowka from './svg/Leśniczówka_gajówka.svg';
import Lotnisko from './svg/Lotnisko.svg';
import Lotnisko_sportowe_ladowisko from './svg/Lotnisko sportowe_lądowisko.svg';
import Lowisko from './svg/Łowisko.svg';
import Mechanik_samochodowy from './svg/Mechanik samochodowy.svg';
import Miejsce_biwakowe from './svg/Miejsce biwakowe.svg';
import Muzeum from './svg/Muzeum.svg';
import Myjnia_samochodowa from './svg/Myjnia samochodowa.svg';
import Obiekt_sportowy_boisko from './svg/Obiekt sportowy_boisko.svg';
import Osrodek_zdrowia from './svg/Ośrodek zdrowia.svg';
import Agroturystyka from './svg/Agroturystyka.svg';
import Hostel from './svg/Hostel.svg';
import Hotel from './svg/Hotel.svg';
import Inny_obiekt_noclegowy from './svg/Inny obiekt noclegowy.svg';
import Kemping_pole_namiotowe from './svg/Kemping_pole namiotowe.svg';
import Kwatera_prywatna_mieszkanie from './svg/Kwatera prywatna_mieszkanie.svg';
import Motel from './svg/Motel.svg';
import Ośrodek_wczasowy_pensjonat from './svg/Ośrodek wczasowy_pensjonat.svg';
import park from './svg/Park.svg';
import parking from './svg/Parking.svg';
import parking_rowerowy from './svg/Parking rowerowy.svg';
import plaza_kapielisko from './svg/Plaża_kąpielisko.svg';
import poczta from './svg/Poczta.svg';
import pokoj_goscinny from './svg/Pokój gościnny.svg';
import pole_bitwy from './svg/Pole bitwy.svg';
import policja from './svg/Policja.svg';
import pomnik_przyrody_nieozywionej from './svg/Pomnik przyrody nieożywionej.svg';
import pomnik_przyrody_ozywionej from './svg/Pomnik przyrody ożywionej.svg';
import pomnik_mogila from './svg/Pomnik_mogiła.svg';
import port_przystan from './svg/Port_przystań.svg';
import postoj_taksowek from './svg/Postój taksówek.svg';
import przechowalnia_bagazu from './svg/Przechowalnia bagażu.svg';
import przedszkole_zlobek from './svg/Przedszkole_żłobek.svg';
import przejscie_graniczne from './svg/Przejście graniczne.svg';
import przeprawa_promowa from './svg/Przeprawa promowa.svg';
import przystanek_autobusowy from './svg/Przystanek autobusowy.svg';
import przystanek_kolejowy from './svg/Przystanek kolejowy.svg';
import przystanek_tramwajowy from './svg/Przystanek tramwajowy.svg';
import punkt_widokowy from './svg/Punkt widokowy.svg';
import restauracja_kawiarnia_bar from './svg/Restauracja_kawiarnia_bar.svg';
import ruiny from './svg/Ruiny.svg';
import sad from './svg/Sąd.svg';
import salon_pieknosci_fryzjer_kosmetyczka from './svg/Salon piękności_fryzjer_kosmetyczka.svg';
import sanatorium from './svg/Sanatorium.svg';
import schronisko_mlodziezowe from './svg/Schronisko młodzieżowe.svg';
import schronisko_turystyczne from './svg/Schronisko turystyczne.svg';
import sciezka_rowerowa from './svg/Ścieżka rowerowa.svg';
import siedziba_urzedu from './svg/Siedziba urzędu.svg';
import sklep_specjalistyczny from './svg/Sklep specjalistyczny.svg';
import sklep_spozywczo_przemyslowy from './svg/Sklep spożywczo-przemysłowy.svg';
import stacja_paliw from './svg/Stacja paliw.svg';
import stadion_hala_sportowa from './svg/Stadion_hala sportowa.svg';
import stadnina_koni from './svg/Stadnina koni.svg';
import stanowisko_archeologiczne from './svg/Stanowisko archeologiczne.svg';
import straz_pozarna from './svg/Straż pożarna.svg';
import synagoga_zabytkowa from './svg/Synagoga zabytkowa.svg';
import synagoga from './svg/Synagoga.svg';
import szczyt_punkt_wysokosciowy from './svg/Szczyt_punkt wysokościowy.svg';
import szkola from './svg/Szkoła.svg';
import szlak_inny from './svg/Szlak inny.svg';
import szlak_kajakowy from './svg/Szlak kajakowy.svg';
import szlak_konny from './svg/Szlak konny.svg';
import szlak_Nordic_Walking_czarny from './svg/Szlak Nordic Walking czarny.svg';
import szlak_Nordic_Walking_czerwony from './svg/Szlak Nordic Walking czerwony.svg';
import szlak_Nordic_Walking_inny from './svg/Szlak Nordic Walking inny.svg';
import szlak_Nordic_Walking_niebieski from './svg/Szlak Nordic Walking niebieski.svg';
import szlak_Nordic_Walking_zielony from './svg/Szlak Nordic Walking zielony.svg';
import szlak_Nordic_Walking_zolty from './svg/Szlak Nordic Walking żółty.svg';
import szlak_pieszy_czarny from './svg/Szlak pieszy czarny.svg';
import szlak_pieszy_czerwony from './svg/Szlak pieszy czerwony.svg';
import szlak_pieszy_inny from './svg/Szlak pieszy inny.svg';
import szlak_pieszy_niebieski from './svg/Szlak pieszy niebieski.svg';
import szlak_pieszy_zielony from './svg/Szlak pieszy zielony.svg';
import szlak_pieszy_zolty from './svg/Szlak pieszy żółty.svg';
import szlak_przyrodniczo_edukacyjny_czarny from './svg/Szlak przyrodniczo-edukacyjny czarny.svg';
import szlak_przyrodniczo_edukacyjny_czerwony from './svg/Szlak przyrodniczo-edukacyjny czerwony.svg';
import szlak_przyrodniczo_edukacyjny_inny from './svg/Szlak przyrodniczo-edukacyjny inny.svg';
import szlak_przyrodniczo_edukacyjny_niebieski from './svg/Szlak przyrodniczo-edukacyjny niebieski.svg';
import szlak_przyrodniczo_edukacyjny_zielony from './svg/Szlak przyrodniczo-edukacyjny zielony.svg';
import szlak_przyrodniczo_edukacyjny_zolty from './svg/Szlak przyrodniczo-edukacyjny żółty.svg';
import szlak_roweorwy from './svg/Szlak roweorwy.svg';
import szlak_rowerowy_czarny from './svg/Szlak rowerowy czarny.svg';
import szlak_rowerowy_czerwony from './svg/Szlak rowerowy czerwony.svg';
import szlak_rowerowy_inny from './svg/Szlak rowerowy inny.svg';
import szlak_rowerowy_niebieski from './svg/Szlak rowerowy niebieski.svg';
import szlak_rowerowy_zielony from './svg/Szlak rowerowy zielony.svg';
import szlak_rowerowy_zolty from './svg/Szlak rowerowy żółty.svg';
import szpital from './svg/Szpital.svg';
import tama_jaz from './svg/Tama_jaz.svg';
import targowisko from './svg/Targowisko.svg';
import teatr from './svg/Teatr.svg';
import teren_dawnej_wsi from './svg/Teren dawnej wsi.svg';
import toaleta_publiczna from './svg/Toaleta publiczna.svg';
import trasa_biegowa from './svg/Trasa biegowa.svg';
import trasa_narciarska from './svg/Trasa narciarska.svg';
import uczelnia_wyzsza from './svg/Uczelnia wyższa.svg';
import usługi from './svg/Usługi.svg';
import wiata_turystyczna from './svg/Wiata turystyczna.svg';
import wieza_widokowa from './svg/Wieża widokowa.svg';
import wyciag_narciarski from './svg/Wyciąg narciarski.svg';
import wypozyczalnia_samochodow from './svg/Wypożyczalnia samochodów.svg';
import wypozyczalnia_sprzetu_rekreacyjnego from './svg/Wypożyczalnia sprzętu rekreacyjnego.svg';
import wypozyczalnia_stacja_rowerow from './svg/Wypożyczalnia_stacja rowerów.svg';
import zajazd from './svg/Zajazd.svg';
import zamek from './svg/Zamek.svg';
import zbiornik_wodny from './svg/Zbiornik wodny.svg';
import zoo from './svg/ZOO.svg';
import zrodlo_mineralne from './svg/Źródło mineralne.svg';
import zrodlo from './svg/Źródło.svg';
// od linii 2119
(() => {

  let _mapowaniePoi = (data) => {
     if (data.properties[2] === 'Krzyż/figura') {
      return Krzyz_figura;
    }
    if (data.properties[2] === 'Amfiteatr'){
    	return amfiteatr;
    }
    if (data.properties[2] === 'Bank'){
    	return bank;
    }
    if (data.properties[2] === 'Bankomat'){
    	return Bankomat;
    }
    if (data.properties[2] === 'Basen'){
    	return Basen;
    }
    if (data.properties[2] === 'Biblioteka'){
    	return Biblioteka;
    }
    if (data.properties[2] === 'Budynek zabytkowy'){
    	return Budynek_zabytkowy;
    }
    if (data.properties[2] === 'Bunkier'){
    	return Bunkier;
    }
    if (data.properties[2] === 'Cerkiew'){
    	return Cerkiew;
    }
    if (data.properties[2] === 'Cerkiew zabytkowa'){
    	return Cerkiew_zabytkowa;
    }
    if (data.properties[2] === 'Cmentarz'){
    	return Cmentarz;
    }
    if (data.properties[2] === 'Cmentarz zabytkowy'){
    	return Cmentarz_zabytkowy;
    }
    if (data.properties[2] === 'Dom kultury/świetlica'){
    	return Dom_kultury_świetlica;
    }
    if (data.properties[2] === 'Dom zdrojowy'){
    	return Dom_zdrojowy;
    }
    if (data.properties[2] === 'Dworek/pałac'){
    	return Dworek_palac;
    }
    if (data.properties[2] === 'Dworzec autobusowy'){
    	return Dworzec_autobusowy;
    }
    if (data.properties[2] === 'Dworzec/stacja kolejowa'){
    	return Dworzec_stacja_kolejowa;
    }
    if (data.properties[2] === 'Filharmonia/opera'){
    	return Filharmonia_opera;
    }
    if (data.properties[2] === 'Fontanna'){
    	return Fontanna;
    }
    if (data.properties[2] === 'Fort/twierdza'){
    	return Fort_twierdza;
    }
    if (data.properties[2] === 'Gabinet lekarski'){
    	return Gabinet_lekarski;
    }
    if (data.properties[2] === 'Galeria handlowa'){
    	return Galeria_handlowa;
    }
    if (data.properties[2] === 'Grodzisko/kurhan'){
    	return Grodzisko_kurhan;
    }
    if (data.properties[2] === 'Informacja turystyczna'){
    	return Informacja_turystyczna;
    }
    if (data.properties[2] === 'Inny obiekt historyczny'){
    	return Inny_obiekt_historyczny;
    }
    if (data.properties[2] === 'Inny obiekt kultu religijnego'){
    	return Inny_obiekt_kultu_religijnego;
    }
    if (data.properties[2] === 'Inny obiekt kultury i rozrywki'){
    	return Inny_obiekt_kultury_i_rozrywki;
    }
    if (data.properties[2] === 'Inny obiekt przyrodniczy'){
    	return Inny_obiekt_przyrodniczy;
    }
    if (data.properties[2] === 'Inny obiekt sportu i wypoczynku'){
    	return Inny_obiekt_sportu_i_wypoczynku;
    }
    if (data.properties[2] === 'Inny obiekt użyteczności publicznej'){
    	return Inny_obiekt_użyteczności_publicznej;
    }
    if (data.properties[2] === 'Inny obiekt związany z transportem'){
    	return Inny_obiekt_związany_z_transportem;
    }
    if (data.properties[2] === 'Interesująca osobliwość przyrodnicza'){
    	return Interesujaca_osobliwosc_przyrodnicza;
    }
    if (data.properties[2] === 'Kamieniołom'){
    	return Kamieniolom;
    }
    if (data.properties[2] === 'Kapliczka'){
    	return Kapliczka;
    }
    if (data.properties[2] === 'Kino'){
    	return Kino;
    }
    if (data.properties[2] === 'Kirkut'){
    	return Kirkut;
    }
    if (data.properties[2] === 'Klub gier i innych rozrywek'){
    	return Klub_gier_i_innych_rozrywek;
    }
    if (data.properties[2] === 'Klub muzyczny'){
    	return Klub_muzyczny;
    }
    if (data.properties[2] === 'Kościół'){
    	return Kosciol;
    }
    if (data.properties[2] === 'Kościół zabytkowy'){
    	return Kosciol_zabytkowy;
    }
    if (data.properties[2] === 'Leśniczówka/gajówka'){
    	return Lesniczowka_gajowka;
    }
    if (data.properties[2] === 'Lotnisko'){
    	return Lotnisko;
    }
    if (data.properties[2] === 'Lotnisko sportowe/lądowisko'){
    	return Lotnisko_sportowe_ladowisko;
    }
    if (data.properties[2] === 'Łowisko'){
    	return Lowisko;
    }
    if (data.properties[2] === 'Mechanik samochodowy'){
    	return Mechanik_samochodowy;
    }
    if (data.properties[2] === 'Miejsce biwakowe'){
    	return Miejsce_biwakowe;
    }
    if (data.properties[2] === 'Muzeum'){
    	return Muzeum;
    }
    if (data.properties[2] === 'Myjnia samochodowa'){
    	return Myjnia_samochodowa;
    }
    if (data.properties[2] === 'Obiekt sportowy/boisko'){
    	return Obiekt_sportowy_boisko;
    }
    if (data.properties[2] === 'Ośrodek zdrowia'){
    	return Osrodek_zdrowia;
    }
    if (data.properties[2] === 'Agroturystyka'){
    	return Agroturystyka;
    }
    if (data.properties[2] === 'Hostel'){
    	return Hostel;
    }
    if (data.properties[2] === 'Hotel'){
    	return Hotel;
    }
    if (data.properties[2] === 'Inny obiekt noclegowy'){
    	return Inny_obiekt_noclegowy;
    }
    if (data.properties[2] === 'Kemping/pole namiotowe'){
    	return Kemping_pole_namiotowe;
    }
    if (data.properties[2] === 'Kwatera prywatna/mieszkanie'){
    	return Kwatera_prywatna_mieszkanie;
    }
    if (data.properties[2] === 'Motel'){
    	return Motel;
    }
    if (data.properties[2] === 'Ośrodek wczasowy/pensjonat'){
    	return Ośrodek_wczasowy_pensjonat;
    }
    if (data.properties[2] === 'Park') {
      return park;
    }
    if (data.properties[2] === 'Parking') {
      return parking;
    }
    if (data.properties[2] === 'Parking rowerowy') {
      return parking_rowerowy;
    }
    if (data.properties[2] === 'Plaża/kąpielisko') {
      return plaza_kapielisko;
    }
    if (data.properties[2] === 'Poczta') {
      return poczta;
    }
    if (data.properties[2] === 'Pokój gościnny') {
      return pokoj_goscinny;
    }
    if (data.properties[2] === 'Pole bitwy') {
      return pole_bitwy;
    }
    if (data.properties[2] === 'Policja') {
      return policja;
    }
    if (data.properties[2] === 'Pomnik przyrody nieożywionej') {
      return pomnik_przyrody_nieozywionej;
    }
    if (data.properties[2] === 'Pomnik przyrody ożywionej') {
      return pomnik_przyrody_ozywionej;
    }
    if (data.properties[2] === 'Pomnik/mogiła') {
      return pomnik_mogila;
    }
    if (data.properties[2] === 'Port/przystań') {
      return port_przystan;
    }
    if (data.properties[2] === 'Postój taksówek') {
      return postoj_taksowek;
    }
    if (data.properties[2] === 'Przechowalnia bagażu') {
      return przechowalnia_bagazu;
    }
    if (data.properties[2] === 'Przedszkole/żłobek') {
      return przedszkole_zlobek;
    }
    if (data.properties[2] === 'Przejście graniczne') {
      return przejscie_graniczne;
    }
    if (data.properties[2] === 'Przeprawa promowa') {
      return przeprawa_promowa;
    }
    if (data.properties[2] === 'Przystanek autobusowy') {
      return przystanek_autobusowy;
    }
    if (data.properties[2] === 'Przystanek kolejowy') {
      return przystanek_kolejowy;
    }
    if (data.properties[2] === 'Przystanek tramwajowy') {
      return przystanek_tramwajowy;
    }
    if (data.properties[2] === 'Punkt widokowy') {
      return punkt_widokowy;
    }
    if (data.properties[2] === 'Restauracja/kawiarnia/bar') {
      return restauracja_kawiarnia_bar;
    }
    if (data.properties[2] === 'Ruiny') {
      return ruiny;
    }
    if (data.properties[2] === 'Sąd') {
      return sad;
    }
    if (data.properties[2] === 'Salon piękności/fryzjer/kosmetyczka') {
      return salon_pieknosci_fryzjer_kosmetyczka;
    }
    if (data.properties[2] === 'Sanatorium') {
      return sanatorium;
    }
    if (data.properties[2] === 'Schronisko młodzieżowe') {
      return schronisko_mlodziezowe;
    }
    if (data.properties[2] === 'Schronisko turystyczne') {
      return schronisko_turystyczne;
    }
    if (data.properties[2] === 'Parking') {
      return sciezka_rowerowa;
    }
    if (data.properties[2] === 'Siedziba urzędu') {
      return siedziba_urzedu;
    }
    if (data.properties[2] === 'Sklep specjalistyczny') {
      return sklep_specjalistyczny;
    }
    if (data.properties[2] === 'Sklep spożywczo-przemysłowy') {
      return sklep_spozywczo_przemyslowy;
    }
    if (data.properties[2] === 'Stacja paliw') {
      return stacja_paliw;
    }
    if (data.properties[2] === 'Stadion/hala sportowa') {
      return stadion_hala_sportowa;
    }
    if (data.properties[2] === 'Stadnina koni') {
      return stadnina_koni;
    }
    if (data.properties[2] === 'Stanowisko archeologiczne') {
      return stanowisko_archeologiczne;
    }
    if (data.properties[2] === 'Straż pożarna') {
      return straz_pozarna;
    }
    if (data.properties[2] === 'Synagoga zabytkowa') {
      return synagoga_zabytkowa;
    }
    if (data.properties[2] === 'Synagoga') {
      return synagoga;
    }
    if (data.properties[2] === 'Szczyt/punkt wysokościowy') {
      return szczyt_punkt_wysokosciowy;
    }
    if (data.properties[2] === 'Szkoła') {
      return szkola;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_inny;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_kajakowy;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_konny;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_Nordic_Walking_czarny;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_Nordic_Walking_czerwony;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_Nordic_Walking_inny;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_Nordic_Walking_niebieski;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_Nordic_Walking_zielony;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_Nordic_Walking_zolty;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_pieszy_czarny;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_pieszy_czerwony;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_pieszy_inny;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_pieszy_niebieski;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_pieszy_zielony;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_pieszy_zolty;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_przyrodniczo_edukacyjny_czarny;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_przyrodniczo_edukacyjny_czerwony;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_przyrodniczo_edukacyjny_inny;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_przyrodniczo_edukacyjny_niebieski;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_przyrodniczo_edukacyjny_zielony;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_przyrodniczo_edukacyjny_zolty;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_roweorwy;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_rowerowy_czarny;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_rowerowy_czerwony;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_rowerowy_inny;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_rowerowy_niebieski;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_rowerowy_zielony;
    }
    if (data.properties[2] === 'Parking') {
      return szlak_rowerowy_zolty;
    }
    if (data.properties[2] === 'Szpital') {
      return szpital;
    }
    if (data.properties[2] === 'Tama/jaz') {
      return tama_jaz;
    }
    if (data.properties[2] === 'Targowisko') {
      return targowisko;
    }
    if (data.properties[2] === 'Teatr') {
      return teatr;
    }
    if (data.properties[2] === 'Teren dawnej wsi') {
      return teren_dawnej_wsi;
    }
    if (data.properties[2] === 'Toaleta publiczna') {
      return toaleta_publiczna;
    }
    if (data.properties[2] === 'Parking') {
      return trasa_biegowa;
    }
    if (data.properties[2] === 'Parking') {
      return trasa_narciarska;
    }
    if (data.properties[2] === 'Uczelnia wyższa') {
      return uczelnia_wyzsza;
    }
    if (data.properties[2] === 'Usługi') {
      return usługi;
    }
    if (data.properties[2] === 'Wiata turystyczna') {
      return wiata_turystyczna;
    }
    if (data.properties[2] === 'Wieża widokowa') {
      return wieza_widokowa;
    }
    if (data.properties[2] === 'Wyciąg narciarski') {
      return wyciag_narciarski;
    }
    if (data.properties[2] === 'Wypożyczalnia samochodów') {
      return wypozyczalnia_samochodow;
    }
    if (data.properties[2] === 'Wypożyczalnia sprzętu rekreacyjnego') {
      return wypozyczalnia_sprzetu_rekreacyjnego;
    }
    if (data.properties[2] === 'Wypożyczalnia/stacja rowerów') {
      return wypozyczalnia_stacja_rowerow;
    }
    if (data.properties[2] === 'Zajazd') {
      return zajazd;
    }
    if (data.properties[2] === 'Zamek') {
      return zamek;
    }
    if (data.properties[2] === 'Zbiornik wodny') {
      return zbiornik_wodny;
    }
    if (data.properties[2] === 'ZOO') {
      return zoo;
    }
    if (data.properties[2] === 'Źródło mineralne') {
      return zrodlo_mineralne;
    }
    if (data.properties[2] === 'Źródło') {
      return zrodlo;
    }
    if (data.properties[2] === 'Inne') {
      return inne;
    }
    return inne;
  }

  module.exports = { mapowaniePoi: _mapowaniePoi };
})();


// WEBPACK FOOTER //
// src/components/MapControl/svgImports.js